import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  border-radius: 3px;
  border: dashed 1px #f1a047;
  background-color: #fef7e8;
  padding: 15px;
  margin-bottom: 16px;

  img {
    margin-right: 10px;
    margin-left: 10px;
  }

  button {
    margin-left: 0;
    margin-bottom: 0;
  }

  p {
    margin-top: 10px;
    margin-left: 10px;
  }
`;
